import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Home is where each role starts the day: directors on the overview, everyone
 * else on their own list of work.
 */
export const Route = createFileRoute("/_app/")({
  beforeLoad: ({ context }) => {
    throw redirect({ to: context.me.user.role === "director" ? "/dashboard" : "/my-tasks" });
  },
});
